import React from 'react';
import { useSelector } from 'react-redux';

import { validationSchema, validationSchemaNotRequired } from './validation-schema';

// Domain imports.
import { Loader } from '@domain/components';
import { useSaveIncidentFactory, } from '@domain/hooks';
import { getPrevNextPagePath, generatePageContent, chooseLogoSize, checkIsFeedback } from '@domain/helpers';

import { FilesUploadPage } from '@domain/pages';
import { detectContentType } from '@domain/content';
import { useQuestionnaire } from '@domain/providers';
import { useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';

function OtherFilesUpload() {


  const insurer = useSelector(state => state.insurer)
  const incident = useSelector(state => state.incident);
  const files = useSelector(state => state.files)
  const otherFiles = files.otherFiles
  const themeContext = useTheme();

  const { questionnaire } = useQuestionnaire()

  const location = useLocation()
  const currentPath = location.pathname;
  const page = questionnaire.find(page => page.path === currentPath)
  const saveBehavior = page ? page.saveBehavior : undefined

  const saveIncident = useSaveIncidentFactory(incident, saveBehavior);


  if (!otherFiles || !insurer || !incident || !questionnaire) {
    return <Loader />;
  }

  const isFeedback = checkIsFeedback(incident)
  const isPageBeforeSuccess = questionnaire[questionnaire.length - 2].path === currentPath

  const pagePath = getPrevNextPagePath(
    questionnaire,
    incident,
    currentPath,
    files,
    isFeedback
  );
  const nextPage = pagePath.nextPage !== currentPath
    ? pagePath.nextPage
    : undefined;

  function feedbackCause() {
    const page = insurer.configuration.find(page => page.name === 'otherfiles')
    const feedbacktext = page.feedbacktext ? decodeURIComponent(page.feedbacktext) : null
    return feedbacktext
  }

  const contentType = detectContentType(insurer)
  const pageName = questionnaire.find(page => page.path === currentPath).name
  const content = generatePageContent(contentType, insurer, incident, false, false, pageName)

  const legend = content["over-title-text"]
  const heading = content["title"]
  const firstParagraph = content["intro-text"]
  const secondParagraph = content["second-text"]
  const customHelpLink = content["custom-help-link"]
  const helpLinkText = content["help-link-text"]
  const useCustomLogo = content["use-custom-logo"]
  const faqs = content["faqs"]
  const validationText = content["validation-text"]

  const validationSchemaToBeUsed = () => {
    if (page.required === false) {
      return validationSchemaNotRequired
    }
    return validationSchema(validationText)
  }

  const middleLogo = {
    src: insurer.logoURL || '',
    alt: insurer.brandName || 'uw verzekeraar',
    width: '100%',
    height: chooseLogoSize(themeContext.logoSize),
  }

  return (
    <FilesUploadPage
      nextPage={nextPage}
      prevPage={pagePath.prevPage}
      questionnaire={questionnaire}
      saveIncident={saveIncident}
      buttonText="Volgende"
      currentPath={currentPath}
      filesSetName="otherFiles"
      filesSet={otherFiles}
      feedbackCause={feedbackCause()}
      validationSchema={validationSchemaToBeUsed()}
      faqs={faqs}
      legend={legend}
      heading={heading}
      firstParagraph={firstParagraph}
      secondParagraph={secondParagraph}
      files={files}
      incident={incident}
      insurer={insurer}
      isFeedback={isFeedback}
      isPageBeforeSuccess={isPageBeforeSuccess}
      customHelpLink={customHelpLink}
      helpLinkText={helpLinkText}
      customMiddleLogo={useCustomLogo}
      middleLogo={middleLogo}
      showDesktopParagraphOnMobile={true}
    />
  );
}

export default OtherFilesUpload
